












































import { getEventByPhrase, getEventByID } from "@/models/Event.ts";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class EventAssociation extends Vue {
  @Prop({ type: Number }) id!: number;
  @Prop({ type: String }) role!: string;

  private initItem!: any;
  private loading: boolean = false;
  private items: object[] = [];
  private phrase: string = "";
  private openAPI: boolean = false; // this is a hack to prevent :search-input.sync calling the api on model change

  async created() {
    if (this.id) {
      try {
        let event = await getEventByID(this.id);
        this.initItem = event;
        this.items = [this.initItem];
      } catch (error) {
        console.error(error);
      }
    }
  }

  @Watch("phrase")
  async onPhraseChanged(value: any, oldValue: any) {
    if (!this.openAPI) {
      this.openAPI = true;
      return;
    }
    this.loading = true;
    if (value && value.length > 1 && value !== oldValue) {
      let response = await getEventByPhrase(value);

      this.items = [...response.data];
      if (!!this.initItem) {
        this.items.push(this.initItem);
      }
    }
    this.loading = false;
  }

  updateValue(value: any) {
    let payload = { id: this.id, role: this.role, ...value };
    this.openAPI = false;
    // Manage role
    if (payload.id === null || typeof payload.id === "undefined") {
      payload.id = null;
      payload.role = null;
    } else if (payload.role === null || payload.role === "") {
      payload.role = "Partial figure (Added)";
    }

    this.$emit("change", payload);
  }
}
